import { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  fruitBaskets,
  getProduct,
  images,
  initialAddresses,
  products,
  serviceAreas,
  shakeProducts,
  timeSlots,
  weekdays,
} from "../data";
import { useApp } from "../store";
import {
  AddressCard,
  Brand,
  DeliveryCard,
  EmptyState,
  PageHeader,
  PrimaryButton,
  ProductCard,
  StatusBadge,
} from "../components/UI";

import "../css/OrderSuccess.css";
export function OrderSuccess() {
  const { draft } = useApp();
  const location = useLocation();
  const confirmed = location.state?.delivery;
  const address = location.state?.address;
  const product =
    location.state?.product || getProduct(draft?.productId) || shakeProducts[0];
  const deliveryDate = location.state?.deliveryDate || draft?.startDate;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="success-page">
      <div className="success-card">
        <div className="success-icon">
          <i className="fa-solid fa-check" />
        </div>
        <span className="eyebrow">Schedule confirmed</span>
        <h1>You’re scheduled!</h1>
        <p>
          Your <strong>{product.name}</strong> is now part of your routine.
        </p>
        <div className="success-details">
          <div>
            <i className="fa-regular fa-calendar" />
            <span>
              <small>Next delivery</small>
              <strong>
                {deliveryDate
                  ? new Date(`${deliveryDate}T00:00:00`).toLocaleDateString(
                      "en-IN",
                      {
                        weekday: "long",
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      },
                    )
                  : "Your next delivery"}
              </strong>
            </span>
          </div>
          <div>
            <i className="fa-regular fa-clock" />
            <span>
              <small>Preferred window</small>
              <strong>
                {confirmed?.timeSlot ||
                  draft?.deliveryTimeSlot ||
                  "Your selected window"}
              </strong>
            </span>
          </div>
          <div>
            <i className="fa-solid fa-location-dot" />
            <span>
              <small>Delivering to</small>
              <strong>
                {address
                  ? `${address.type || "Address"} · ${address.area || address.city || "Pune"}`
                  : "Your saved address"}
              </strong>
            </span>
          </div>
        </div>
        <div className="fresh-note text-start">
          <i className="fa-solid fa-leaf" />
          <div>
            <strong>We’ll handle the fresh part.</strong>
            <p>
              We’ll prepare or buy fresh according to your scheduled delivery.
            </p>
          </div>
        </div>
        <PrimaryButton to="/deliveries" className="w-100">
          View my deliveries
        </PrimaryButton>
        <Link to="/home" className="btn btn-soft w-100 mt-2">
          Back to home
        </Link>
      </div>
    </div>
  );
}

export default OrderSuccess;
